import React, { ReactElement } from 'react';
import SecuredComponent from './component/SecuredComponent';
import UserRole from '../../model/currentuser/UserRole';
import { useUserContext } from '../../context/UserContext';

interface Props {
  children: ReactElement;
  allowForRoles?: Array<UserRole>;
  additionalCheck?: boolean;
  elseChildren?: ReactElement;
}

const Secured = ({
  children, allowForRoles, additionalCheck = true, elseChildren = null,
}: Props): ReactElement => {
  const { pouzivatel } = useUserContext();

  return (
    <SecuredComponent
      pouzivatel={pouzivatel}
      allowForRoles={allowForRoles}
      additionalCheck={additionalCheck}
      elseChildren={elseChildren}
    >
      {children}
    </SecuredComponent>
  );
};

export default Secured;
